import { render, staticRenderFns } from "./SemesterCarousel.vue?vue&type=template&id=48fc0e7d&scoped=true&"
import script from "./SemesterCarousel.vue?vue&type=script&lang=js&"
export * from "./SemesterCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SemesterCarousel.vue?vue&type=style&index=0&id=48fc0e7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc0e7d",
  null
  
)

export default component.exports